<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
      el-tabs.title(v-model="activeName" @tab-click="handleTabClick")
        el-tab-pane(:label="'销售订单('+count1+')'" name="first")
        el-tab-pane(:label="'对账单('+count2+')'" name="second")
        el-tab-pane(:label="'销售发票('+count3+')'" name="three")
    div(style="height:110px")
    el-main.white.pa-3.ma-4
      el-alert(v-if="data.length==0" title="该待办没有数据" type="error" :closable="false")
      div(v-else v-for="(item,i) in data" :key="i")
        div.pointer.pa-2(style="display:flex" @click="goDetail(item)")
          div
            i.mr-1.iconfont.display-1(v-html="getIcon(item)")
          div(style="flex:1 1")
            div.red--text.font-weight-bold [{{item.type_name}}]{{item.title}}
            div.grey--lighten3--text {{item.content}}
          div.text-right.red--text 已经超期{{item.days}}天
        el-divider(v-if="i<data.length-1")
      el-pagination.my-4.text-center(v-if="data.length>0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)   
</template>
<script>
export default {
  data() {
    return {
      flag: false,
      h: "",
      loading: false,
      activeName: "first",
      list: {
        bill_type: "DD",
        page_num: 1,
        page_size: 10,
      },
      count: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      list1: {
        bill_type: "DD",
        page_num: 1,
        page_size: 10,
      },
      list2: {
        bill_type: "DZ",
        page_num: 1,
        page_size: 10,
      },
      list3: {
        bill_type: "FP",
        page_num: 1,
        page_size: 10,
      },
      data: [],
    };
  },
  methods: {
    goDetail(e) {
      switch (e.type) {
        case "DZ":
          if (e.status == 5) {
            this.goto("/supply/account_statement_edit/" + e.id + "/2");
          } else {
            this.goto("/supply/account_statement_detail/" + e.id + "/3");
          }
          return;
        case "DD":
          if (e.status == 2) {
            this.goto("/supply/sales_order_detail/" + e.id + "/2");
          } else {
            this.goto("/supply/sales_order_detail/" + e.id + "/3");
          }
          return;
        case "FP":
          if (e.status == 1 || e.status == 4) {
            this.goto("/supply/sales_invoice_detail/" + e.id + "/2");
          } else {
            this.goto("/supply/sales_invoice_detail/" + e.id + "/3");
          }
          return;
        default:
          return;
      }
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleTabClick(tab) {
      let data = this.list;
      if (tab.name == "first") {
        data.page_size = this.list1.page_size;
        data.page_num = this.list1.page_num;
        data.bill_type = this.list1.bill_type;
      } else if (tab.name == "second") {
        data.page_size = this.list2.page_size;
        data.page_num = this.list2.page_num;
        data.bill_type = this.list2.bill_type;
      } else if (tab.name == "three") {
        data.page_size = this.list3.page_size;
        data.page_num = this.list3.page_num;
        data.bill_type = this.list3.bill_type;
      }
      this.$router.push({
        path: this.$route.path,
        hash: "#" + tab.name,
        query: data,
      });
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.todo.getList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count1 = res.count1 ? res.count1 : 0;
        this.count2 = res.count3 ? res.count3 : 0;
        this.count3 = res.count4 ? res.count4 : 0;
        switch (this.activeName) {
          case "first":
            this.count = this.count1;
            break;
          case "second":
            this.count = this.count2;
            break;
          case "three":
            this.count = this.count3;
            break;
          default:
            break;
        }
      }
    },
    initList() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
      } else {
        this.list.bill_type = this.list1.bill_type;
      }
      let bill_type = this.list.bill_type;
      switch (bill_type) {
        case "DD":
          this.activeName = "first";
          break;
        case "DZ":
          this.activeName = "second";
          break;
        default:
          this.list.bill_type = "FP";
          this.activeName = "three";
          break;
      }
      switch (this.activeName) {
        case "first":
          this.list1.page_size = this.list.page_size;
          this.list1.page_num = this.list.page_num;
          break;
        case "second":
          this.list2.page_size = this.list.page_size;
          this.list2.page_num = this.list.page_num;
          break;
        case "three":
          this.list3.page_size = this.list.page_size;
          this.list3.page_num = this.list.page_num;
          break;
        default:
          break;
      }
      this.$router.push({
        path: this.$route.path,
        hash: "#" + this.activeName,
        query: this.list,
      });
    },
    init() {
      this.activeName = this.$route.hash
        ? this.$route.hash.split("#")[1]
        : "first";
      this.initList();
      this.getList();
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>